import { type Kampanya } from "@/mocks/kampanyalar";

interface IkinciAdimProps {
  kampanya: Kampanya;
  onFirsatlariGor: () => void;
}

export default function IkinciAdim({ kampanya, onFirsatlariGor }: IkinciAdimProps) {
  const bilgiler = [
    {
      ikon: "ri-flashlight-line",
      baslik: "Hızlı ve Görünür Sonuç",
      aciklama: "İlk seanstan itibaren fark edilir değişimler yaşarsınız. Uzman ekibimiz en kısa sürede en iyi sonucu hedefler.",
    },
    {
      ikon: "ri-heart-pulse-line",
      baslik: "Uzman Kadro",
      aciklama: "Alanında 10+ yıl deneyimli estetisyen ve uzmanlarımız, her uygulamayı titizlikle gerçekleştirir.",
    },
    {
      ikon: "ri-shield-check-line",
      baslik: "Güvenli Uygulama",
      aciklama: "Tüm uygulamalarımız sertifikalı cihazlar ve onaylı ürünlerle, hijyenik ortamda gerçekleştirilir.",
    },
    {
      ikon: "ri-price-tag-3-line",
      baslik: "Uygun Fiyat Garantisi",
      aciklama: "Premium kaliteyi herkes için erişilebilir kılıyoruz. Esnek ödeme seçenekleri mevcuttur.",
    },
  ];

  return (
    <section id="ikinci-adim" className="py-20 md:py-28 bg-[#1A0F0A]">
      <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
        {/* Badge */}
        <span className="inline-block bg-[#E8B86D]/15 text-[#E8B86D] text-xs font-bold px-5 py-2 rounded-full tracking-[0.2em] uppercase mb-6 border border-[#E8B86D]/25">
          İkinci Adım
        </span>

        <h2
          className="font-black italic text-white leading-tight mb-5"
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: "clamp(1.8rem, 4vw, 3rem)",
          }}
        >
          Bu Uygulama Sizin İçin
          <br />
          <span
            style={{
              background: "linear-gradient(135deg, #C9943A, #E8B86D)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            Uygun Mu?
          </span>
        </h2>

        <p className="text-white/60 text-base md:text-lg leading-relaxed mb-12 font-light">
          <strong className="text-[#E8B86D] font-semibold">{kampanya.baslik}</strong> uygulaması, cildinizin ve vücudunuzun ihtiyaçlarına göre kişiselleştirilen bir programdır.
        </p>

        {/* Info Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12 text-left">
          {bilgiler.map((b) => (
            <div key={b.baslik} className="bg-white/5 rounded-xl p-5 flex items-start gap-4 border border-white/10 hover:border-[#E8B86D]/30 transition-colors">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#E8B86D]/15 flex-shrink-0">
                <i className={`${b.ikon} text-[#E8B86D] text-xl`} />
              </div>
              <div>
                <h4 className="text-white font-bold text-sm mb-1">{b.baslik}</h4>
                <p className="text-white/50 text-xs leading-relaxed font-light">{b.aciklama}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Testimonials strip */}
        <div className="bg-white/5 rounded-2xl p-6 mb-10 border border-white/10">
          <div className="flex items-center justify-center gap-2 mb-3">
            {[1,2,3,4,5].map((s) => (
              <i key={s} className="ri-star-fill text-[#E8B86D] text-base" />
            ))}
            <span className="text-white font-bold text-sm ml-1">4.9 / 5</span>
          </div>
          <p className="text-white/60 text-sm italic font-light">
            &ldquo;Elora Beauty Lounge&apos;da aldığım hizmet beklentilerimin çok üzerindeydi. Kesinlikle tavsiye ediyorum.&rdquo;
          </p>
          <p className="text-[#E8B86D] text-xs font-bold mt-2">— 5.000+ mutlu müşteri</p>
        </div>

        {/* CTA */}
        <button
          onClick={onFirsatlariGor}
          className="w-full bg-[#E8B86D] hover:bg-[#F5D08A] text-[#1A0F0A] font-black py-5 rounded-xl text-lg transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-3"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Size Özel Fırsatları Gör
          <i className="ri-arrow-right-line text-xl" />
        </button>

        <p className="text-white/30 text-xs mt-4 font-light">
          Ücretsiz danışmanlık · Bağlayıcı değil
        </p>
      </div>
    </section>
  );
}